import React from "react";
import { Alert, Divider, Flex, Form, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";

import { DefaultSelect } from "ui";
import { _isRequired, getBankAlertMessage, renderBankOptions } from "utils";
import { FORM_VALIDATION_DEBOUNCE } from "constants/form";
import { useStores } from "stores";

interface BankAccountSelectionProps {
  loading: boolean;
  selectedAccountId: string | null;
  bankAccountsStore: any;
  contractCard: any;
  onAccountChange: (value: string) => void;
  form: any;
}

export const BankAccountSelection = observer((props: BankAccountSelectionProps) => {
  const { loading, selectedAccountId, bankAccountsStore, contractCard, onAccountChange, form } = props;
  const { user } = useStores();
  const companyId = user.userInfo?.company_id;
  const isExpContract = contractCard.card.direction === "EXP";

  useEffect(() => {
    if (companyId && isExpContract) {
      bankAccountsStore.fetchBankAccounts(companyId).then(() => {
        if (bankAccountsStore.bankAccounts.length > 0) {
          const defaultAccount = bankAccountsStore.bankAccounts.find((item: any) => item.isDefault);

          const bankAccountByContractBik = bankAccountsStore.bankAccounts.find(
            (item: any) => item.bik === contractCard.card.bankBik
          );

          if (bankAccountByContractBik) {
            form.setFieldsValue({
              accountId: bankAccountByContractBik.id,
            });
            onAccountChange(bankAccountByContractBik.id);
          } else {
            form.setFieldsValue({
              accountId: defaultAccount?.id,
            });
            onAccountChange(defaultAccount?.id || "");
          }
        }
      });
    }
  }, [companyId, contractCard.card.bankBik, form, isExpContract, bankAccountsStore, onAccountChange]);

  const bankAlertMessage = getBankAlertMessage(
    contractCard.card.bankBik,
    bankAccountsStore.bankAccounts,
    selectedAccountId
  );

  return (
    <Flex vertical id="create-bid-account-select">
      <Typography.Text strong className="margin-bottom-xs margin-top-lg">
        Банковские реквизиты для получения рублёвого платежа
      </Typography.Text>
      <Form.Item
        name="accountId"
        rules={[_isRequired("Банковские реквизиты обязательны для ввода")]}
        validateDebounce={FORM_VALIDATION_DEBOUNCE}
        className="full-width"
        children={
          <DefaultSelect disabled={loading} size="large" placeholder="Реквизиты" onChange={onAccountChange}>
            {renderBankOptions(bankAccountsStore.bankAccounts)}
          </DefaultSelect>
        }
      />
      {bankAlertMessage && <Alert message={bankAlertMessage} type="warning" showIcon />}
      <Divider />
    </Flex>
  );
});
